import { useState, useEffect } from "react";
import { singletonHook } from "react-singleton-hook";
// Width
const useWidthImplem = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return width;
};
export const useWidth = singletonHook(window.innerWidth, useWidthImplem);
// Breakpoint conversion
const BREAKPOINTS = {
    lg: 1920,
    md: 1440,
    sm: 1280,
    xs: 960,
    xxs: 0
};
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["lg"] = BREAKPOINTS.lg] = "lg";
    Breakpoints[Breakpoints["md"] = BREAKPOINTS.md] = "md";
    Breakpoints[Breakpoints["sm"] = BREAKPOINTS.sm] = "sm";
    Breakpoints[Breakpoints["xs"] = BREAKPOINTS.xs] = "xs";
    Breakpoints[Breakpoints["xxs"] = BREAKPOINTS.xxs] = "xxs";
    Breakpoints[Breakpoints["xxxs"] = BREAKPOINTS.xxs] = "xxxs";
})(Breakpoints || (Breakpoints = {}));
const widthToBreakpoint = (width) => Math.max(...Object.keys(Breakpoints)
    .filter((value) => width > Number(value))
    .map((value) => Number(value)));
const useBreakpointImplem = () => {
    const width = useWidth();
    return widthToBreakpoint(width);
};
export const useBreakpoint = singletonHook(widthToBreakpoint(window.innerWidth), useBreakpointImplem);
